import React, { Component } from 'react'


export default class ErrorMessage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeError: false,
            timeout: 3000,
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    showMessage = () => {
        this.setState({
            activeError: true,
        });
        this.closeMessage();
    }

    closeMessage = () => {
        setTimeout(
            () =>
                this.setState({
                    activeError: false,
                }),
            this.state.timeout
        )
    }

    render() {
        return <div
                    className={`error_message ${
                        this.state.activeError ? 'active' : ''
                    }`}
                >
                    <p>{this.translation[this.props.errorMessage]}</p>
                </div>;
    }
}